import { store } from '../state';
import { show, hide } from 'redux-modal';

export const mostrarModal = (nombre, props) => {
	return store.dispatch(show(nombre, props));
}

export const ocultarModal = (nombre) => {
	return store.dispatch(hide(nombre));
}